import { useState } from 'react';

import { Input } from '@/components/ui/catalyst/input';
import { ArtifactReference } from '@/services/types/artifact-digest-types';

import { ReferenceCard } from '../cards';

interface ReferencesSectionProps {
  references: ArtifactReference[];
}

export const ReferencesSection = ({ references }: ReferencesSectionProps) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!references || references.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">No references available</p>
    );
  }

  // Filter references based on search term
  const filteredReferences = references.filter(
    (reference) =>
      reference.value.toLowerCase().includes(searchTerm.toLowerCase()) ||
      reference.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      reference.type.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div>
      <Input
        placeholder="Search references..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-2 text-xs h-8"
      />

      {filteredReferences.length === 0 ? (
        <p className="text-sm text-muted-foreground">No matching references</p>
      ) : (
        <div className="divide-y divide-zinc-100 dark:divide-zinc-800">
          {filteredReferences.map((reference) => (
            <ReferenceCard key={reference.id} reference={reference} />
          ))}
        </div>
      )}
    </div>
  );
};
